import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgServices = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 14.5L14.5 11.9V4.1L8 1.5L1.5 4.1V11.9L8 14.5ZM1.5 4.1L8 6.7M8 6.7L14.5 4.1M8 6.7V14.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgServices;
